import { CreditCard, Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const cardBrand = (brand) => ({
  visa: "Visa",
  mastercard: "MasterCard",
  amex: "American Express",
  discover: "Discover",
  diners: "Diners Club",
}[brand] || (brand ? brand.charAt(0).toUpperCase() + brand.slice(1) : "card"));

export const UpsellConfirmDialog = ({ offer, savedCard, loadingCard, busy, onOpenChange, onConfirm, onOtherOptions }) => {
  const open = !!offer;
  const canUseSavedCard = !!savedCard?.last4;
  const savedLabel = canUseSavedCard
    ? `Use ${cardBrand(savedCard.brand)} •••• ${savedCard.last4}`
    : "Use saved card";

  return (
    <Dialog open={open} onOpenChange={busy ? undefined : onOpenChange}>
      <DialogContent data-testid="upsell-confirm-modal" className="border-gold/30 bg-ink text-white sm:rounded-3xl">
        <DialogHeader>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold mb-1">Confirm your add-on</p>
          <DialogTitle data-testid="upsell-confirm-title" className="font-display text-2xl font-extrabold tracking-tight">
            Add {offer?.title} for ${offer?.price}?
          </DialogTitle>
          <DialogDescription className="text-slate-400 leading-relaxed">
            Confirm the charge below, or use other options to pay with a different card.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-2xl border border-white/10 bg-obsidian/70 p-4" aria-live="polite">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-xl bg-gold/15 flex items-center justify-center shrink-0">
              <CreditCard className="h-5 w-5 text-gold" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-bold text-white">
                {loadingCard ? "Finding your saved card..." : canUseSavedCard ? `${cardBrand(savedCard.brand)} ending in ${savedCard.last4}` : "No saved card found"}
              </p>
              <p className="text-xs text-slate-500">Nothing charges until you confirm.</p>
            </div>
          </div>
        </div>

        <div className="space-y-3 pt-1">
          <button
            data-testid="upsell-confirm-saved-card-btn"
            onClick={onConfirm}
            disabled={busy || loadingCard || !canUseSavedCard}
            className="w-full bg-gradient-to-r from-gold to-[#FB8500] text-black font-extrabold px-6 py-4 rounded-xl shadow-[0_0_30px_rgba(255,183,3,0.25)] hover:scale-[1.01] active:scale-[0.99] transition-transform cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <CreditCard className="h-5 w-5" />}
            {busy ? "Charging..." : savedLabel}
          </button>
          <button
            data-testid="upsell-confirm-other-options"
            onClick={onOtherOptions}
            disabled={busy}
            className="w-full text-sm text-slate-400 hover:text-gold underline underline-offset-4 transition-colors cursor-pointer disabled:opacity-50"
          >
            other options
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
